import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const LegalLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-slate-50 py-16 px-4">
    <div className="max-w-3xl mx-auto bg-white p-10 rounded-[2rem] shadow-sm border border-slate-200">
      <div className="mb-8 pb-8 border-b border-slate-100">
        <h1 className="text-3xl font-black text-slate-900 mb-2">{title}</h1>
        <p className="text-slate-500 text-sm font-medium">Sist oppdatert: {lastUpdated}</p>
      </div>
      <div className="prose prose-slate max-w-none prose-headings:font-black prose-a:text-blue-600">
        {children}
      </div>
    </div>
  </div>
);

export const Terms = () => (
  <LegalLayout title="Vilkår og Betingelser" lastUpdated="1. Mars 2024">
    <h3>1. Introduksjon</h3>
    <p>Velkommen til Sales Work CRM. Ved å bruke vår tjeneste godtar du disse vilkårene.</p>
    <h3>2. Abonnement og Betaling</h3>
    <p>Tjenesten faktureres månedlig eller årlig på forskudd. Oppsigelse må skje før neste periode starter.</p>
    <h3>3. Bruksrett</h3>
    <p>Vi gir deg en ikke-eksklusiv, ikke-overførbar rett til å bruke programvaren til interne forretningsformål.</p>
    <h3>4. Ansvar</h3>
    <p>Sales Work AS er ikke ansvarlig for indirekte tap, datatap eller driftsavbrudd.</p>
  </LegalLayout>
);

export const Privacy = () => (
  <LegalLayout title="Personvernerklæring (GDPR)" lastUpdated="1. Mars 2024">
    <h3>1. Behandlingsansvarlig</h3>
    <p>Sales Work AS er behandlingsansvarlig for dine data. Kontakt oss på privacy@saleswork.no.</p>
    <h3>2. Hvilke data vi samler inn</h3>
    <p>Vi lagrer kontaktinfo, salgsdata og aktivitetslogger for å levere CRM-tjenesten.</p>
    <h3>3. Dine rettigheter</h3>
    <p>Du har rett til innsyn, retting og sletting av dine data iht. GDPR.</p>
    <h3>4. Databehandlere</h3>
    <p>Vi bruker underleverandører som Stripe (betaling) og Supabase (database) som er underlagt DPA.</p>
  </LegalLayout>
);

export const Cookies = () => (
  <LegalLayout title="Informasjonskapsler (Cookies)" lastUpdated="1. Mars 2024">
    <p>Vi bruker cookies for å sikre at du forblir innlogget og for å analysere trafikk.</p>
    <ul>
      <li><strong>Nødvendige:</strong> For innlogging og sikkerhet.</li>
      <li><strong>Funksjonelle:</strong> Husker dine preferanser (tema, språk).</li>
      <li><strong>Analyse:</strong> Anonymisert statistikk for å forbedre tjenesten.</li>
    </ul>
  </LegalLayout>
);